export default __webpack_public_path__ + "static/media/home.d87cf98c.svg";